import { NavLink, Link } from 'react-router-dom'
import {
  LayoutDashboard,
  Building2,
  FileText,
  ScrollText,
  CreditCard,
  TestTube2,
  FileType,
  Mail,
  Inbox,
  MessagesSquare,
  Settings,
} from 'lucide-react'
import { ROUTES, APP } from '@/lib/constants'

const NAV = [
  { to: ROUTES.DASHBOARD, label: 'Dashboard', icon: LayoutDashboard },
  { to: ROUTES.TAX_CLIENTS, label: 'Tax-Clients', icon: Building2 },
  { to: ROUTES.DOCUMENTS, label: 'Documents', icon: FileText },
  { to: ROUTES.AUDIT, label: 'Audit', icon: ScrollText },
  { to: ROUTES.BILLING, label: 'Billing', icon: CreditCard },
  { to: ROUTES.SET_PRUEBAS, label: 'Set pruebas', icon: TestTube2 },
  { to: ROUTES.PDF_TEMPLATES, label: 'Plantillas PDF', icon: FileType },
  { to: ROUTES.EMAIL_TEMPLATES, label: 'Plantillas Email', icon: Mail },
  { to: ROUTES.EMAIL_LOG, label: 'Email Log', icon: Inbox },
  { to: ROUTES.PQRSF, label: 'PQRSF', icon: MessagesSquare },
  { to: ROUTES.SETTINGS, label: 'Settings', icon: Settings },
] as const

export function Sidebar() {
  return (
    <aside className="hidden w-60 flex-none border-r border-border bg-bg-surface lg:block">
      <div className="flex h-16 items-center gap-2 border-b border-border px-5">
        <Link to={ROUTES.DASHBOARD} className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-brand-500 font-mono text-xs font-bold text-white">
            Tx
          </div>
          <span className="text-sm font-semibold text-fg-primary">{APP.name}</span>
        </Link>
      </div>
      <nav className="px-3 py-4">
        {NAV.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === ROUTES.DASHBOARD}
              className={({ isActive }) =>
                `mb-1 flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-brand-50 text-brand-700'
                    : 'text-fg-secondary hover:bg-bg-elevated hover:text-fg-primary'
                }`
              }
            >
              <Icon className="h-4 w-4 flex-none" />
              {item.label}
            </NavLink>
          )
        })}
      </nav>
    </aside>
  )
}
